import { createContext } from 'react';

import type { KeyboardEvent } from '../../../core/types/events.js';

interface InformationOverlayTriggerProps {
  'aria-expanded'?: boolean | 'true' | 'false';
  'aria-haspopup'?:
    | boolean
    | 'menu'
    | 'listbox'
    | 'tree'
    | 'grid'
    | 'dialog'
    | 'true'
    | 'false';
  'aria-controls'?: string;
  onKeyDown?: (e: KeyboardEvent) => void;
}

export interface InformationOverlayContextType {
  color: 'neutral' | 'primary' | 'success' | 'warning' | 'critical';
  overlayTriggerProps: InformationOverlayTriggerProps;
  id: string;
  isOpen: boolean;
}

const DEFAULT_CONTEXT: InformationOverlayContextType = {
  color: 'neutral',
  overlayTriggerProps: {},
  id: 'information-overlay',
  isOpen: false,
};

export const InformationOverlayContext =
  createContext<InformationOverlayContextType>(DEFAULT_CONTEXT);
